import React from 'react'

const Laptop = () => {
  return (
    <svg
      width="40"
      height="29"
      viewBox="0 0 40 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 4.41162C4 2.20248 5.79086 0.411621 8 0.411621H32C34.2091 0.411621 36 2.20248 36 4.41162V20.4116C36 21.5162 35.1046 22.4116 34 22.4116H6C4.89543 22.4116 4 21.5162 4 20.4116V4.41162ZM0 25.4116C0 24.8593 0.447715 24.4116 1 24.4116H14.0026C14.0009 24.4409 14 24.4703 14 24.5C14 25.3284 14.6716 26 15.5 26H24.5C25.3284 26 26 25.3284 26 24.5C26 24.4703 25.9991 24.4409 25.9974 24.4116H39C39.5523 24.4116 40 24.8593 40 25.4116V26.4116C40 27.5162 39.1046 28.4116 38 28.4116H2C0.895431 28.4116 0 27.5162 0 26.4116V25.4116ZM6 4.41162C6 3.85934 6.44772 3.41162 7 3.41162H33C33.5523 3.41162 34 3.85934 34 4.41162C34 4.96391 33.5523 5.41162 33 5.41162H7C6.44771 5.41162 6 4.96391 6 4.41162Z"
        fill="#C58C5F"
      />
    </svg>
  )
}

export default Laptop
